<script>
  import * as R from 'ramda';
  import { getContext } from 'svelte';

  import SearchItem from '~/search/search-item';
  import { translateOrDefault as __ } from '~/data-utils';
  import action from '~/action';
  import { searchMapFeatures } from 'apps/imd/stores';

  import ItemScore from './ItemScore.svelte';
  import Thumbnail from 'components/Thumbnail.svelte';
  import Title, { H2 } from 'components/Title.svelte';
  const app = getContext('app');

  export let searchResults = [];

  $: resulItems = searchResults.map(getRowData);

  // Accessors for 'title' and 'subtitle' by type
  const accessors = {
    facility: [['title'], ['floor']],
    newsAndEvent: [['title'], ['undefined']],
    offer: [['title'], ['store', 'name']],
    store: [['name'], ['floor', 'description']],
  };

  function getRowData(row) {
    const { item, score } = row;
    const data = SearchItem.getTypeData(item, app);
    const [title = '–', subtitle = '–'] = R.paths(accessors[item.type], data);
    return Object.assign({ title, subtitle, data, score, result: row }, item);
  }

  function key({ id, type }, index) {
    return index != undefined ? `${index}:${type}:${id}` : `${type}:${id}`;
  }
  function clickSearchResult(item) {
    const { id, type, data } = item;

    switch (type) {
    case 'store':
      if (shouldNavigateToMapView()) {
        action.showStoreOnMap(id);
      } else {
        action.showStoreInfo(id);
      }
      break;

    case 'newsAndEvent':
      action.showNewsArticle(id);
      break;

    case 'offer':
      action.showTipsForStore(data.store.id);
      break;

    case 'facility':
      action.showFacilityOnMap(id);
      break;
    }

  }

  function shouldNavigateToMapView() {
    return !app.feature('storeView') || $searchMapFeatures;
  }
</script>

<ul class="results" title="Search results">
  {#each resulItems as item, i (key(item, i))}
    {#if item.data}
      <!-- svelte-ignore a11y-no-redundant-roles -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <li
        class="results__item"
        on:click={() => clickSearchResult(item)}
        data-testid={key(item)}
        role="listitem"
      >
        <Thumbnail type={item.type} data={item.data} />
        <div class="text">
          <Title tag={H2}>{__(item.title)}</Title>
          <span class="floor">{item.subtitle}</span>
          <ItemScore
            word={item.title}
            score={item.score}
            result={item.result}
          />
        </div>
      </li>
    {/if}
  {:else}
    <p class="no-results">
      {__('search.noResults')}
    </p>
  {/each}
</ul>


<style>
  .results {
    margin: 32px 96px 48px 216px;
    padding-left: 16px;
  }

  .results__item {
    --borderColor: var(--search-results--item--borderColor, transparent);
    display: flex;
    position: relative;
    padding: 24px 16px;
    border-top: 2px solid var(--borderColor);
    list-style: none;
  }

  .results__item :global(.thumb) {
    margin-right: 32px;
  }

  .results__item :global(h2) {
    --marginBottom: 0;
  }
</style>
